import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Specialties.module.css';

// Import images from assets
import specialty1 from '../../assets/images/Home-page-categories/flange-screws-nuts-flange-screws-nuts-plumbing-99210454.jpg';
import specialty6 from '../../assets/images/Home-page-categories/DSC_535126622.jpg';
import specialty4 from '../../assets/images/Home-page-categories/Laser-Technology.jpg';
import specialty5 from '../../assets/images/Home-page-categories/nwnwDSC_5326666jjj7.jpg';
import specialty7 from '../../assets/images/Home-page-categories/WhatsApp-Image-2021-01-21-at-12.56.22-PM.jpeg';
import specialty2 from '../../assets/images/Home-page-categories/16-مصنع-السلاسل.jpg';
import specialty3 from '../../assets/images/Home-page-categories/kisspng-rack-and-pinion-gear-train-sprocket-5b0811f58416c1.9586763815272555415411.png';
import specialty8 from '../../assets/images/Home-page-categories/Untitled.png';

const Specialties = () => {
  const { t } = useTranslation();

  const specialties = [
    {
      id: 1,
      image: specialty1,
      title: t('specialties.item1.title'),
      description: t('specialties.item1.description'),
      link: '/products'
    },
    {
      id: 2,
      image: specialty2,
      title: t('specialties.item2.title'),
      description: t('specialties.item2.description'),
      link: '/products'
    },
    {
      id: 3,
      image: specialty3,
      title: t('specialties.item3.title'),
      description: t('specialties.item3.description'),
      link: '/products'
    },
    {
      id: 4,
      image: specialty4,
      title: t('specialties.item4.title'),
      description: t('specialties.item4.description'),
      link: '/products'
    },
    {
      id: 5,
      image: specialty5,
      title: t('specialties.item5.title'),
      description: t('specialties.item5.description'),
      link: '/products'
    },
    {
      id: 6,
      image: specialty6,
      title: t('specialties.item6.title'),
      description: t('specialties.item6.description'),
      link: '/products'
    },
    {
      id: 7,
      image: specialty7,
      title: t('specialties.item7.title'),
      description: t('specialties.item7.description'),
      link: '/products'
    },
    {
      id: 8,
      image: specialty8,
      title: t('specialties.item8.title'),
      description: t('specialties.item8.description'),
      link: '/products'
    }
  ];

  return (
    <section className={styles.specialtiesSection}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {specialties.map((specialty) => (
            <div key={specialty.id} className={styles.card}>
              <div className={styles.imageWrapper}>
                <img
                  src={specialty.image}
                  alt={specialty.title}
                  className={styles.image}
                />
                <div className={styles.imageOverlay}></div>
              </div>
              <div className={styles.content}>
                <h3 className={styles.title}>{specialty.title}</h3>
                <p className={styles.description}>{specialty.description}</p>
                <a href={specialty.link} className={styles.seeMoreBtn}>
                  <span>{t('specialties.seeMore')}</span>
                  <svg viewBox="0 0 20 20" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Specialties;

